import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import CustomDialog from "../../../components/Dialog/DiaComp";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import HighDrugs from "./Drugs/SectionGuide/HighDrugs/HighDrugs";
import ModerateDrugs from "./Drugs/SectionGuide/ModerateDrugs/ModerateDrugs";
import LowDrugs from "./Drugs/SectionGuide/LowDrugs/LowDrugs";

export default function DiaGuide() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
   
        <Tooltip title="PGx Guidelines" placement="bottom">
            <IconButton onClick={handleOpen} >
                <ScatterPlotIcon  sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
            </IconButton>   
        </Tooltip>
    

    <CustomDialog open={open} onClose={handleClose}

          title="Personalized Clinical Guidelines - Drugs"
          content = {<>  
            
            <Grid container spacing={8} sx={{ display: 'flex', justifyContent:'center', alignItems:'center' }}>
                <Grid item> <LowDrugs /> </Grid>
                <Grid item><ModerateDrugs /> </Grid>
                <Grid item><HighDrugs /></Grid> 
            </Grid>
 </>}

        />
        
</>
)}